export const departments = [
  { value: "sales", label: "Sales" },
  { value: "customer_service", label: "Customer Service" },
  { value: "operations", label: "Operations" },
  { value: "pricing", label: "Pricing" },
  { value: "accounts", label: "Accounts" },
  { value: "hr", label: "HR" },
  { value: "management", label: "Management" },
  { value: "marketing", label: "Marketing" },
  { value: "sales_manager", label: "Sales Manager" },
  { value: "marketplace_handler", label: "Marketplace" },
];

export const access = [
  {
    item_id: "1",
    value: "dashboard",
    label: "Dashboard",
    permissions: ["view"],
  },
  {
    value: "master",
    label: "Master",
    item_id: "2",
    sub_item: [
      {
        value: "rate_master",
        label: "Rate Master",
        item_id: "21",
        sub_item: [
          {
            value: "storage",
            label: "Storage",
            item_id: "211",
            permissions: ["view", "edit"],
          },
          {
            item_id: "212",
            value: "Profit_Margin",
            label: "Profit Margin",
            permissions: ["view", "edit", "add"],
          },
          {
            item_id: "213",
            value: "package",
            label: "Package",
            permissions: ["view", "edit"],
          },
          {
            item_id: "214",
            value: "insurance",
            label: "Insurance",
            permissions: ["view", "edit"],
          },
          {
            item_id: "215",
            value: "courier_additional_charges",
            label: "Courier Additional Charges",
            permissions: ["view", "edit"],
          },
          {
            item_id: "216",
            value: "courier_rates",
            label: "Courier Rates",
            permissions: ["view", "edit"],
          },
          {
            item_id: "21F",
            value: "courier_mode_charges",
            label: "Courier Mode Charges",
            permissions: ["view", "edit"],
          },
          {
            item_id: "21G",
            value: "land_mode_charges",
            label: "Land Mode Charges",
            permissions: ["view", "edit"],
          },
          {
            item_id: "217",
            value: "error_margin",
            label: "Error Margin",
            permissions: ["view", "edit", "add"],
          },
          {
            item_id: "218",
            value: "freight_rates",
            label: "Freight Rates",
            // permissions: ["view"],
            sub_item: [
              {
                item_id: "2181",
                value: "air",
                label: "Air",
                permissions: ["view","edit",'add'],
              },
              {
                item_id: "2182",
                value: "air_consolidation",
                label: "Air Consolidation",
                permissions: ["view","edit",'add'],
              },
              {
                item_id: "2183",
                value: "sea",
                label: "Sea",
                permissions: ["view","edit",'add'],
              },
              {
                item_id: "2184",
                value: "sea_consolidation",
                label: "Sea Consolidation",
                permissions: ["view","edit",'add'],
              },
              {
                item_id: "2185",
                value: "courier",
                label: "Courier",
                permissions: ["view","edit",'add'],
              },
              {
                item_id: "2186",
                value: "land_express",
                label: "Land Express",
                permissions: ["view","edit",'add'],
              },
              {
                item_id: "2187",
                value: "land_consolidation",
                label: "Land Consolidation",
                permissions: ["view","edit",'add'],
              },
            ],
          },
          {
            item_id: "219",
            value: "origin_charges",
            label: "Origin Charges",
            // permissions: ["view"],
            sub_item: [
              {
                item_id: "2191",
                value: "domestic_tariff_1",
                label: "Domestic Tariff 1",
                permissions: ["view","edit",'add'],
              },
              {
                value: "air",
                label: "Air",
                item_id: "2192",
                permissions: ["view","edit",'add'],
              },
              {
                value: "air_consolidation",
                label: "Air Consolidation",
                item_id: "2193",
                permissions: ["view","edit",'add'],
              },
              {
                value: "sea",
                label: "Sea",
                item_id: "2194",
                permissions: ["view","edit",'add'],
              },
              {
                value: "sea_consolidation",
                label: "Sea Consolidation",
                item_id: "2195",
                permissions: ["view","edit",'add'],
              },
              {
                value: "courier",
                label: "Courier",
                item_id: "2196",
                permissions: ["view","edit",'add'],
              },
              {
                value: "cross_border",
                label: "Cross Border",
                item_id: "2197",
                permissions: ["view","edit",'add'],
              },
            ]
          },
          {
            item_id: "220",
            value: "destination_charges",
            label: "Destination Charges",
            // permissions: ["view"],
            sub_item: [
              {
                item_id: "2201",
                value: "destination_inland",
                label: "Inland",
                permissions: ["view","edit",'add'],
              },
              {
                item_id: "2202",
                value: "destination_air",
                label: "Air",
                permissions: ["view","edit",'add'],
              },
              {
                item_id: "2203",
                value: "destination_air_consolidation",
                label: "Air Destination Consolidation",
                permissions: ["view","edit",'add'],
              },
              {
                item_id: "2204",
                value: "destination_sea",
                label: "Sea Destination",
                permissions: ["view","edit",'add'],
              },
              {
                item_id: "2205",
                value: "destination_sea_consolidation",
                label: "Sea Destination Consolidation",
                permissions: ["view","edit",'add'],
              },
              {
                item_id: "2206",
                value: "cross_border",
                label: "Cross Border",
                permissions: ["view","edit",'add'],
              },
            ]
          },
          {
            item_id: "21A",
            label: "Attribute Additional Fees",
            value: "attribute_additional_fees",
            permissions: ["edit"],
          },
          {
            item_id: "21B",
            label: "HS Code Additional Fees",
            value: "hs_code_additional_fees",
            permissions: ["edit",'add']
          },
          {
            item_id: "21C",
            label: "HS Code Remarks",
            value: "hs_code_remarks",
            permissions: ["edit",'add'],
          },
          {
            item_id: "21D",
            label: "HS Code Duty Taxes",
            value: "hs_code_duty_taxes",
            permissions: [],
          },
          {
            item_id: "21E",
            label: "Marketplace Additional Charges",
            value: "marketplace_additional_charges",
            permissions: ["edit"],
          },
        ],
      },
      {
        value: "profile_master",
        label: "Profile Master",
        item_id: "22",
        sub_item: [
          {
            item_id: "221",
            value: "customer",
            label: "Customer",
            sub_item: [
              {
                 item_id: "2211",
                 value: "individual",
                 label: "Individual",
                 permissions: ["view", "add", "edit","delete"],
              },
              {
                 item_id: "2212",
                 value: "retailer",
                 label: "Retailer",
                 permissions: ["view", "add", "edit","delete"],
              },
            ],
          },
          {item_id: "222",
            value: "warehouse",
            label: "Warehouse",
            permissions: ["view", "add", "edit"],
          },
          {item_id: "223",
            value: "product",
            label: "Product",
            permissions: ["view", "add", "edit"],
          },
          {item_id: "224",
            value: "vendors",
            label: "Vendors",
            permissions: ["view", "add", "edit"],
          },
          // {item_id: 225,
          //   value: "sales_customer_service",
          //   label: "Sales / Customer Service",
          //   permissions: ["view", "add", "edit", "delete"],
          // },
        ],
      },
    ],
  },
  {
    item_id: "3",
    value: "add_locations",
    label: "Add Locations",
    sub_item: [
      {
        item_id: "31",
        value: "country",
        label: "Country",
        permissions: ["view", "edit", "add"],
      },
      {
        item_id: "32",
        value: "port",
        label: "Port",
        permissions: ["view", "edit", "delete", "add"],
      },
      {
        item_id: "33",
        value: "courier_country_service",
        label: "Courier Country Service",
        permissions: ["view", "edit", "delete", "add"],
      },
    ],
  },
  {
    item_id: "4",
    value: "operation",
    label: "Operation",
    sub_item: [
      {
        item_id: "41",
        value: "crm",
        label: "CRM",
        sub_item: [
          {
            item_id: "411",
            value: "enquiry",
            label: "Enquiry",
            permissions: ["view", "edit", "delete", "add"],
          },
          {
            item_id: "412",
            value: "jobs_bookings",
            label: "Jobs Bookings",
            permissions: ["view", "edit", "delete", "add"],
          },
          {
            item_id: "413",
            value: "jobs_closed",
            label: "Jobs Closed",
            permissions: ["view"],
          },
          {
            item_id: "414",
            value: "follow_up",
            label: "Follow Up",
            permissions: ["view"],
          },
          {
            item_id: "415",
            value: "jobs_deleted",
            label: "Jobs Deleted",
            permissions: ["view", "add"],
          },
          {
            item_id: "416",
            value: "outstanding_jobs",
            label: "Outstanding Jobs",
            permissions: ["view"],
          },
        ],
      },
      {
        item_id: "42",
        value: "accounts",
        label: "Accounts",
        sub_item: [
          {
            item_id: "421",
            value: "advanced_received",
            label: "Advanced Received ",
            permissions: ["view", "add"],
          },
          {
            item_id: "422",
            value: "receive_payment",
            label: "Receive Payment",
            permissions: ["view", "edit"],
          },
          {
            item_id: "423",
            value: "payout_retailer",
            label: "Payout Retailer",
            permissions: ["view", "edit"],
          },
          {
            item_id: "424",
            value: "credit_note",
            label: "Credit Note",
            permissions: ["view", "add"],
          },
          {
            item_id: "425",
            label: "Financially Closed",
            value: "financially_closed",
            sub_menu: ["view"],
          },
        ],
      },
      {
        item_id: "43",
        value: "reports",
        label: "Reports",
        sub_item: [
          {
            item_id: "431",
            value: "performance",
            label: "Performance",
            permissions: ["view"],
          },
          {
            item_id: "432",
            value: "shipment_wise_performance",
            label: "Shipment Wise Performance",
            permissions: ["view"],
          },
          {
            item_id: "433",
            value: "add_ons",
            label: "Add Ons",
            permissions: ["view"],
          },
          {
            item_id: "434",
            value: "retailer/Customer_wise_performance",
            label: "Retailer / Customer Wise Performance",
            permissions: ["view"],
          },
          {
            item_id: "435",
            value: "retailer_incentive",
            label: "Retailer Incentive",
            permissions: ["view"],
          },
          {
            item_id: "440",
            value: "invoice_report",
            label: "Invoice Report",
            permissions: ["view"],
          },
          {
            item_id: "436",
            value: "vendor",
            label: "Vendor",
            permissions: ["view"],
          },
          {
            item_id: "437",
            value: "retailer_purchase_inv_value",
            label: "Retailer Purchase Inv Value",
            permissions: ["view"],
          },
          {
            item_id: "438",
            value: "customer_service",
            label: "Customer Service",
            permissions: ["view"],
          },
          {
            item_id: "439",
            value: "sales/tele_report",
            label: "Sales / Tele Report",
            permissions: ["view"],         
           },
           {
            item_id: "43a",
            value: "tracking_report",
            label: "Tracking",
            permissions: ["view"],
          },
          {
            item_id: "43b",
            label: "Financially Closed",
            value: "financially_closed_report",
            sub_menu: ["view"],
          },
          {
            item_id: "43c",
            label: "Customer Report",
            value: "customer_Report",
            sub_menu: [],
          },

        ],
      },
      {
        item_id: "44",
        value: "pick_up_scheduler",
        label: "Pick Up Scheduler",
        permissions: ["view", "edit"],
      },
      {
        item_id: "45",
        value: "tracking",
        label: "Tracking",
        permissions: ["view", "edit"],
      },
      {
        item_id: "46",
        value: "online_transaction",
        label: "Online Transaction",
        permissions: ["view"],
      },
    ],
  },
  {
    item_id: "5",
    value: "promo",
    label: "Promo",
    permissions: ["view", "edit", "add"],
  },
  {
    item_id: "6",
    value: "weblink",
    label: "Weblink",
    sub_item: [
      {
        item_id: "61",
        value: "category",
        label: "Category",
        permissions: ["view", "edit",'add','delete'],
      },
      {
        item_id: "62",
        value: "sub_category",
        label: "Sub Category",
        permissions: ["view", "edit",'add','delete'],
      },
      {
        item_id: "63",
        value: "web_link_retailer",
        label: "Web Link Retailer",
        permissions: ["view", "edit",'add','delete'],
      },
      {
        item_id: "64",
        value: "weblink_enquiry",
        label: "Enquiry",
        permissions: ["view"],
      },
    ],
  },
  {
    item_id: "7",
    value: "dutyandtax",
    label: "Duties And Taxes",
    permissions: ["view", "edit", "delete", "add"],
  },
  {
    item_id: "9",
    value: "gallery",
    label: "Gallery",
    permissions: ["view", "delete", "add"],
  },
  {
    item_id: 'a',
    value: "blogs",
    label: "Blogs",
    permissions: ["view", "edit", "delete", "add"],
  },
  {
      item_id: "b",
      label: "Calculator",
      value: "calculator",
      sub_item: [
        {
          item_id: "b1",
          label: "Wooden Box",
          value: "wooden_box_calculator",
          permissions: [],
        },
        {
          item_id: "b2",
          label: "Insurance",
          value: "insurance_calculator",
          permissions: [],
        },
        {
          item_id: "b3",
          label: "Duty & Tax",
          value: "duty_and_tax_calculator",
          permissions: [],
        },
      ],
    },
];
